import { defineStore } from "pinia";
import tamUngLuongService from "@/services/tamUngLuongService";

export const useTamUngLuongStore = defineStore("tamUngLuong", {
  state: () => ({
    // user
    my: {
      list: [],
      page: { number: 0, totalPages: 0, totalElements: 0, size: 10 },
      loading: false,
      acting: false,
      error: null,
    },

    // admin
    admin: {
      list: [],
      page: { number: 0, totalPages: 0, totalElements: 0, size: 10 },
      loading: false,
      acting: false,
      error: null,
      filters: {
        from: "",
        to: "",
        status: "ALL",
        keyword: "",
        userId: "",
      },
    },
  }),

  actions: {
    // ========= USER =========
    async loadMy(params = {}) {
      this.my.loading = true;
      this.my.error = null;
      try {
        const res = await tamUngLuongService.myList({
          page: this.my.page.number,
          size: this.my.page.size,
          ...params,
        });
        // Spring Page hoặc list thường
        const data = res.data;
        if (Array.isArray(data)) {
          this.my.list = data;
          this.my.page = {
            ...this.my.page,
            totalPages: 1,
            totalElements: data.length,
          };
        } else {
          this.my.list = data.content || [];
          this.my.page = {
            number: data.number ?? 0,
            size: data.size ?? this.my.page.size,
            totalPages: data.totalPages ?? 0,
            totalElements: data.totalElements ?? 0,
          };
        }
      } catch (e) {
        this.my.error =
          e?.response?.data?.message || e.message || "Load my advance failed";
      } finally {
        this.my.loading = false;
      }
    },

    async createMy({ soTien, ghiChu }) {
      this.my.acting = true;
      this.my.error = null;
      try {
        await tamUngLuongService.createMy({ soTien, ghiChu });
        await this.loadMy({ page: 0 });
      } catch (e) {
        this.my.error =
          e?.response?.data?.message || e.message || "Create advance failed";
        throw e;
      } finally {
        this.my.acting = false;
      }
    },

    async cancelMy(id) {
      this.my.acting = true;
      try {
        await tamUngLuongService.cancelMy(id);
        await this.loadMy();
      } finally {
        this.my.acting = false;
      }
    },

    changeMyPage(p) {
      this.my.page.number = Math.max(0, p);
      return this.loadMy();
    },

    // ========= ADMIN =========
    async loadAdmin(params = {}) {
      this.admin.loading = true;
      this.admin.error = null;
      try {
        const res = await tamUngLuongService.adminList({
          page: this.admin.page.number,
          size: this.admin.page.size,
          ...this.admin.filters,
          ...params,
        });
        const data = res.data;
        this.admin.list = data.content || [];
        this.admin.page = {
          number: data.number ?? 0,
          size: data.size ?? this.admin.page.size,
          totalPages: data.totalPages ?? 0,
          totalElements: data.totalElements ?? 0,
        };
      } catch (e) {
        this.admin.error =
          e?.response?.data?.message ||
          e.message ||
          "Load admin advance failed";
      } finally {
        this.admin.loading = false;
      }
    },

    changeAdminPage(p) {
      this.admin.page.number = Math.max(0, p);
      return this.loadAdmin();
    },

    async approve(id, ghiChuAdmin) {
      this.admin.acting = true;
      try {
        await tamUngLuongService.approve(id, { ghiChuAdmin });
        await this.loadAdmin();
      } finally {
        this.admin.acting = false;
      }
    },

    async reject(id, lyDoTuChoi) {
      this.admin.acting = true;
      try {
        await tamUngLuongService.reject(id, { lyDoTuChoi });
        await this.loadAdmin();
      } finally {
        this.admin.acting = false;
      }
    },

    async uploadProof(id, file) {
      this.admin.acting = true;
      try {
        const fd = new FormData();
        fd.append("file", file);
        await tamUngLuongService.uploadProof(id, fd);
        await this.loadAdmin();
      } finally {
        this.admin.acting = false;
      }
    },
  },
});
